/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  StorageStorageProtocolsGetPresignedDownloadUrlRequest,
  StorageStorageProtocolsGetPresignedDownloadUrlResponse,
  StorageStorageProtocolsGetPresignedUploadUrlRequest,
  StorageStorageProtocolsGetPresignedUploadUrlResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Storage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Storage
   * @name PresignedUploadCreate
   * @request POST:/storage/presigned/upload
   */
  presignedUploadCreate = (data: StorageStorageProtocolsGetPresignedUploadUrlRequest, params: RequestParams = {}) =>
    this.http.request<StorageStorageProtocolsGetPresignedUploadUrlResponse, any>({
      path: `/storage/presigned/upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Storage
   * @name PresignedDownloadCreate
   * @request POST:/storage/presigned/download
   */
  presignedDownloadCreate = (data: StorageStorageProtocolsGetPresignedDownloadUrlRequest, params: RequestParams = {}) =>
    this.http.request<StorageStorageProtocolsGetPresignedDownloadUrlResponse, any>({
      path: `/storage/presigned/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
